/**
 * Lightweight logger for Gibbs modules.
 *
 * Wraps console methods with a [Gibbs] prefix and supports log-level
 * filtering via setLevel(). Defaults to 'warn' in production.
 *
 * @module gibbs/logger
 */

const LEVELS = {
    debug: 0, info: 1, warn: 2, error: 3, silent: 4,
};

let currentLevel = LEVELS.warn;

export function setLevel(level) {
    if (LEVELS[level] !== undefined) currentLevel = LEVELS[level];
}

export function debug(...args) {
    if (currentLevel <= LEVELS.debug) console.debug('[Gibbs]', ...args);
}

export function info(...args) {
    if (currentLevel <= LEVELS.info) console.info('[Gibbs]', ...args);
}

export function warn(...args) {
    if (currentLevel <= LEVELS.warn) console.warn('[Gibbs]', ...args);
}

export function error(...args) {
    if (currentLevel <= LEVELS.error) console.error('[Gibbs]', ...args);
}
